module.exports = __webpack_public_path__ + "static/media/success.74633448.png";